import React from "react";
import { Card, Divider } from "antd";
function CustomDashboardCard({ item, index }) {
  return (
    <>
      {/* <div style={{display:"flex"}}> */}
      <Card
        size="small"
        style={{
          backgroundColor: "WhiteSmoke",
          height: "100%",
          width: "190px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              textAlign: "left",
            }}
          >
            <div style={{ fontSize: "25px", fontWeight: "600" }}>
              {item.value}
            </div>
            <div
              style={{
                fontSize: "medium",
                fontWeight: "600",
                color: item.labelColor,
              }}
            >
              {item.label}
            </div>
          </div>
          <div>
            {item.icon}
            {/* <img alt=""
              src={item.icon}
              width="35px"
              height="35px"
              style={{
                backgroundColor: "white",
                padding: "5px",
                borderRadius: "10px",
              }}
            /> */}
          </div>
        </div>
      </Card>
      {/* {index !=3 ?
    <div style={{backgroundColor:"#E5E4E2",borderRadius:"3px",width:"5px"}}></div>:null}
    </div> */}
    </>
  );
}

export default CustomDashboardCard;
